import apiService from 'src/enviroment';

// Lista de fuentes DataStudio
const getFontsDataStudio = async () => {
  try {
    const response = await apiService.get('/admin/datastudio/fuentes/');
    if (response.status === 200) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    return false;
  }
};

// Crear fuente
async function postFontsDataStudio(params) {
  try {
    const response = await apiService.post('/admin/datastudio/fuentes/', params);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  } catch (error) {
    return false;
  }
}

// Editar fuente
const editFontDataStudio = async (params) => {
  try {
    const response = await apiService.put('/admin/datastudio/fuentes/', params);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const delFontDataStudio = async (params) => {
  try {
    const response = await apiService.delete(
      `/admin/datastudio/fuentes/?id=${params}`,
    );
    if (response.status === 200) {
      return response;
    }
    return false;
  } catch (error) {
    return false;
  }
};

const fontsService = {
  getFontsDataStudio,
  postFontsDataStudio,
  editFontDataStudio,
  delFontDataStudio,
};

export default fontsService;
